/// <amd-module name='SuiteCommerce.ItemRecSys.WidgetCct.WidgetModel'/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
define("SuiteCommerce.ItemRecSys.WidgetCct.WidgetModel", ["require", "exports", "underscore", "Backbone", "SC.Configuration", "Session", "Utils", "SuiteCommerce.ItemRecSys.WidgetCct.WidgetSettings", "SuiteCommerce.ItemRecSys.WidgetCct.Model", "SuiteCommerce.ItemRecSys.LogParameters", "SuiteCommerce.ItemRecSys.Instrumentation.Logger", "SuiteCommerce.ItemRecSys.Common.Helper", "Item.Model", "Profile.Model", "LiveOrder.Model"], function (require, exports, _, Backbone_1, Configuration, Session, Utils, WidgetSettings_1, AjaxErrorHelper_1, LogParameters_1, Logger_1, Helper_1, ItemModel, ProfileModel, LiveOrderModel) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetModel = void 0;
    var WidgetModel = /** @class */ (function (_super) {
        __extends(WidgetModel, _super);
        function WidgetModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._itemCollection = new Backbone_1.Collection();
            _this.cmsAdminMessages = Array();
            _this.profile = ProfileModel.getInstance();
            _this.cart = LiveOrderModel.getInstance();
            return _this;
        }
        WidgetModel.prototype.initialize = function (options) {
            this.container = options.container;
            this.instanceId = options.instanceId;
            this._itemCollection = new Backbone_1.Collection();
        };
        ;
        Object.defineProperty(WidgetModel.prototype, "itemCollection", {
            get: function () {
                if (this._itemCollection.isEmpty() && (0, Helper_1.isCmsAdmin)() && !this.isEmptyFallback()) {
                    return new Backbone_1.Collection(__spreadArray([], Array(Number(this.settings.numberOfItems)), true).map(function () { return new ItemModel({ displayname: WidgetModel.PLACEHOLDER_ITEM_NAME }); }));
                }
                return this._itemCollection;
            },
            set: function (itemCollection) {
                this._itemCollection = itemCollection;
                this.trigger('change');
            },
            enumerable: false,
            configurable: true
        });
        WidgetModel.prototype.update = function (settingsRaw) {
            return __awaiter(this, void 0, void 0, function () {
                var newSettings;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, WidgetSettings_1.WidgetSettings.create(settingsRaw, this.container)];
                        case 1:
                            newSettings = _a.sent();
                            if (!this.settings || this.settings.contextDiffers(newSettings)) {
                                this.settings = newSettings;
                                this.reloadWithSuppressedAjaxErrorsMsg();
                            }
                            return [2 /*return*/, jQuery.Deferred];
                    }
                });
            });
        };
        ;
        WidgetModel.prototype.reloadWithSuppressedAjaxErrorsMsg = function () {
            var _this = this;
            var errorHelper = AjaxErrorHelper_1.AjaxErrorHelper.createAndSuppress();
            this.loadItems()
                // @ts-ignore
                .finally(function () {
                errorHelper.restoreAjaxErrorHandling();
                _this.trigger('change');
            });
        };
        ;
        WidgetModel.prototype.loadItems = function () {
            return __awaiter(this, void 0, void 0, function () {
                var recSysApiUrl, recSysResponse, filteredItemIds, searchApiUrl, searchApiResponse, e_1, errMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this._itemCollection = new Backbone_1.Collection();
                            this.cmsAdminMessages = [];
                            try {
                                this.settings.assertWidgetUsecaseOk();
                            }
                            catch (e) {
                                this.cmsAdminMessages.push(e.message ? e.message : this.settings.getNoRecommendationsMessage());
                                return [2 /*return*/, jQuery.Deferred];
                            }
                            this.recSysLogData = {};
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, , 7]);
                            recSysApiUrl = this.settings.getRecSysApiUrl();
                            this.recSysLogData.recSysApiUrl = recSysApiUrl;
                            return [4 /*yield*/, jQuery.ajax({ url: recSysApiUrl })];
                        case 2:
                            recSysResponse = _a.sent();
                            if (!recSysResponse.result || recSysResponse.status !== 'SUCCESS') {
                                throw Error('Invalid response from RecSys api.');
                            }
                            this.recSysLogData = __assign(__assign({}, this.recSysLogData), this.getRecSysResponseLogData(recSysResponse));
                            if (!!_(recSysResponse.result).isEmpty()) return [3 /*break*/, 4];
                            filteredItemIds = this.filterCartItems(recSysResponse.result);
                            searchApiUrl = this.getSearchUrl(filteredItemIds);
                            this.recSysLogData.searchApiUrl = searchApiUrl;
                            return [4 /*yield*/, jQuery.ajax({ url: searchApiUrl })];
                        case 3:
                            searchApiResponse = _a.sent();
                            if (!searchApiResponse.items || searchApiResponse.items.length < 1) {
                                throw Error('Empty or invalid response from search api.');
                            }
                            this.setItemCollection(this.getItemModels(filteredItemIds, searchApiResponse));
                            return [3 /*break*/, 5];
                        case 4:
                            if (!this.recSysLogData.isFallback || this.settings.fallbackType != WidgetSettings_1.FallbackType.NONE) {
                                throw Error('Empty response from RecSys api.');
                            }
                            this.itemCollection = new Backbone_1.Collection();
                            this.cmsAdminMessages.push(this.settings.getNoRecommendationsMessage());
                            _a.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            e_1 = _a.sent();
                            errMessage = 'Could not retrieve recommendations. ' + (e_1.message ? e_1.message : '');
                            Logger_1.Logger.get().error(__assign(__assign({}, this.recSysLogData), { errorMessage: errMessage, subType: LogParameters_1.EventType.ERROR }));
                            console.log('ItemRecSysWidget: ' + errMessage, e_1);
                            this.cmsAdminMessages.push(this.settings.getNoRecommendationsMessage());
                            this.itemCollection = new Backbone_1.Collection();
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/, jQuery.Deferred];
                    }
                });
            });
        };
        ;
        WidgetModel.prototype.setItemCollection = function (models) {
            this.itemCollection = new Backbone_1.Collection(models);
        };
        /**
         * Filter out items in cart and context item if exists
         */
        WidgetModel.prototype.filterCartItems = function (idArr) {
            var filter = this.cart.getItemsIds().map(parseInt);
            if (this.settings.contextItemIds) {
                filter.concat(this.settings.contextItemIds);
            }
            return _(idArr).difference(filter);
        };
        WidgetModel.prototype.getSearchUrl = function (idArr) {
            var fieldsetName = Configuration.get('searchApiMasterOptions.Facets.fieldset', 'search');
            var masterOption = Configuration.get('searchApiMasterOptions.itemDetails') || {};
            var limit = idArr.length;
            var searchParams = __assign(__assign(__assign({}, Session.getSearchApiParams()), masterOption), { limit: limit, fieldset: fieldsetName, n: SC.ENVIRONMENT.siteSettings.siteid, c: SC.ENVIRONMENT.companyId });
            delete searchParams.pcv_all_items;
            delete searchParams.currency;
            if (idArr) {
                searchParams.id = idArr.join(',');
            }
            return Utils.addParamsToUrl(this.profile.getSearchApiUrl(), searchParams);
        };
        ;
        WidgetModel.prototype.getItemModels = function (recSysItemIds, searchApiResponse) {
            return _.chain(recSysItemIds)
                .intersection(_(searchApiResponse.items).pluck('internalid'))
                .first(this.settings.numberOfItems)
                .map(function (id) { return new ItemModel(searchApiResponse.items.find(function (searchItem) { return searchItem['internalid'] === id; })); })
                .value();
        };
        ;
        WidgetModel.prototype.hasItems = function () {
            return !this.itemCollection.isEmpty();
        };
        WidgetModel.prototype.getHeader = function () {
            if (this.recSysLogData && this.recSysLogData.isFallback && this.settings.fallbackHeaderText) {
                return this.settings.fallbackHeaderText;
            }
            return this.settings.headerText;
        };
        WidgetModel.prototype.isEmptyFallback = function () {
            return (this.recSysLogData && this.recSysLogData.isFallback && this.settings && this.settings.fallbackType === WidgetSettings_1.FallbackType.NONE);
        };
        WidgetModel.prototype.getRecSysResponseLogData = function (response) {
            var info = response.info;
            var isHardcodedFallback = !response.info.modelDefinition;
            var isModelFallback = !isHardcodedFallback && (info.modelDefinition.useCase == "SHOPPER_POPULAR_ITEMS" || info.modelDefinition.useCase == "SHOPPER_NEW_ITEMS");
            return {
                widgetUuid: 'UUID' in response ? response.UUID : 'MISSING UUID',
                abTestId: 'abTest' in info ? info.abTest.key : 0,
                modelDefinitionId: isHardcodedFallback ? 0 : info.modelDefinition.key,
                useCase: isHardcodedFallback ? info.fallbackInfo.fallbackName : info.modelDefinition.useCase,
                algorithmName: isHardcodedFallback ? "".concat(info.fallbackInfo.fallbackType, "_").concat(info.fallbackInfo.fallbackName) : info.trainDefinition.algorithm,
                trainDefinitionId: isHardcodedFallback ? 0 : info.trainDefinition.key,
                trainInstanceId: isHardcodedFallback ? 0 : info.trainInstance.key,
                isFallback: isHardcodedFallback || isModelFallback,
                scenarioId: this.settings.scenarioId,
                contextItemIds: JSON.stringify(this.settings.contextItemIds)
            };
        };
        WidgetModel.PLACEHOLDER_ITEM_NAME = 'No Item to Display';
        return WidgetModel;
    }(Backbone_1.Model));
    exports.WidgetModel = WidgetModel;
});
